import { differenceInMinutes, differenceInHours, isToday, isYesterday, format } from 'date-fns';

/**
 * Format a date as human-readable relative time
 *
 * Rules:
 * - "5m ago" (< 1 hour)
 * - "2h ago" (< 24 hours, today)
 * - "Yesterday" (if yesterday)
 * - "Oct 30" (older than yesterday)
 *
 * @param date - Date string or Date object to format
 * @returns Formatted relative time string
 */
export function formatRelativeDate(date: string | Date): string {
  const now = new Date();
  const publishDate = typeof date === 'string' ? new Date(date) : date;

  // Calculate time differences
  const minutesDiff = differenceInMinutes(now, publishDate);
  const hoursDiff = differenceInHours(now, publishDate);

  // Less than 60 minutes ago
  if (minutesDiff < 60) {
    return `${minutesDiff}m ago`;
  }

  // Less than 24 hours ago AND today
  if (hoursDiff < 24 && isToday(publishDate)) {
    return `${hoursDiff}h ago`;
  }

  // Yesterday
  if (isYesterday(publishDate)) {
    return 'Yesterday';
  }

  // Older dates - show as "Oct 30"
  return format(publishDate, 'MMM d');
}
